import React, { useEffect, useState } from 'react';
import { Collapse, Icon, Tooltip } from 'antd';
import { ColumnProps } from 'antd/lib/table';
import { Widget, Button, Table } from '@digital/ui';
import { useRecoilValue } from 'recoil';

import { getDadosGerais, OrdemCompraDadosGerais } from '@app/api/sas/ordemCompra';
import { getAcoesGestorTecnico, IAcaoGestorTecnico } from '@app/api/sas/gestorTecnico';

import {
  ordemCompraIdState,
} from '../atoms';

import ModalAcaoGestorTecnico from './ModalAcaoGestorTecnico';

const { Panel } = Collapse;

interface WidgetAcoesGestorTecnicoProps {
  readOnly?: boolean;
}

const WidgetAcoesGestorTecnico = ({ readOnly = false }: WidgetAcoesGestorTecnicoProps) => {
  const ordemCompraId = useRecoilValue(ordemCompraIdState);

  const [ordemCompra, setOrdemCompra] = useState<OrdemCompraDadosGerais>();
  const [acoes, setAcoes] = useState<IAcaoGestorTecnico[]>([]);
  const [updateAcoes, setUpdateAcoes] = useState<boolean>(false);

  const [acaoSelecionada, setAcaoSelecionada] = useState<IAcaoGestorTecnico | null>(null);

  useEffect(() => {
    if (!ordemCompraId) return;
    getDadosGerais(ordemCompraId).then(d => d && setOrdemCompra(d));
    getAcoesGestorTecnico(ordemCompraId).then(r => r.acoes && setAcoes(r.acoes));
  }, [ordemCompraId]);

  useEffect(() => {
    if (!ordemCompraId) return;
    setAcoes([]);
    getAcoesGestorTecnico(ordemCompraId).then(r => r.acoes && setAcoes(r.acoes));
  }, [updateAcoes]);

  const atualizaTela = () => {
    setUpdateAcoes(!updateAcoes);
  };

  const columns = (): ColumnProps<any>[] => [
    { title: 'Ação', dataIndex: 'acao' },
    {
      title: 'Fornecedor',
      dataIndex: 'nomeFornecedor',
      render: (v) => v || '-'
    },
    {
      title: 'Ação',
      width: '5%',
      render: (_, record: IAcaoGestorTecnico) => (
        <Tooltip title="Executar ação">
          <Button
            icon="arrows-chevron_right"
            onClick={() => setAcaoSelecionada(record)}
            disabled={record.statusAcao !== 'Pendente'}
          />
        </Tooltip>
      )
    },
    {
      title: 'Status',
      render: (_, record: IAcaoGestorTecnico) => {
        if (!record.statusAcao) return '-';
        const statusAcao = record.statusAcao;
        return <span
          style={{
            color: statusAcao === 'Pendente' ? '#fa8c16' : undefined,
            fontWeight: statusAcao === 'Pendente' ? 500 : undefined,
          }}
        >
          {statusAcao}
        </span>
      },
      dataIndex: 'statusAcao'
    },
    {
      title: 'Data limite',
      width: '10%',
      dataIndex: 'dataLimite',
      render: (v) => v ? new Date(v).toLocaleDateString() : "-"
    },
    {
      title: 'Data Execução',
      width: '10%',
      dataIndex: 'dataExecucao',
      render: (v) => v ? new Date(v).toLocaleDateString() : "-"
    },
  ];

  // Não exibir widget se não houver ações
  if (!acoes || acoes.length === 0) {
    return null;
  }

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['acoesGestorTecnico']}
        expandIcon={() => <Icon type="arrows-right_4" />}
      >
        <Panel
          key="acoesGestorTecnico"
          header={`Ações do Gestor Técnico - OC ${ordemCompra && ordemCompra.numero || ''}`}
        >
          <Widget>
            <Table dataSource={acoes} columns={columns()} pagination={false} />
          </Widget>
        </Panel>
      </Collapse>

      {acaoSelecionada && (
        <ModalAcaoGestorTecnico
          visible
          acao={acaoSelecionada}
          ordemCompraId={ordemCompraId}
          onSuccess={atualizaTela}
          onClose={() => setAcaoSelecionada(null)}
          readOnly={readOnly}
        />
      )}
    </>
  );
};

export default WidgetAcoesGestorTecnico;
